export enum TeamTemplateOrderField {
  Created = "Created",
  Name = "Name",
  Archived = "Archived"
}